export default __webpack_public_path__ + "static/media/gestionFlotte.ba9efcae.png";